import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import $ from 'jquery';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import TaxSelect from "../common/pricing/taxselect.component.jsx";
import { patchPricingTableItem, setPricingTableTotals } from '../state/pricing/actions';
import { getPricingTableId } from '../state/pricing/selectors';

class TaxQuote extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            taxId: this.props.taxId || '',
            tableId: this.props.tableId || "",
            billingMethod: this.props.billingMethod || '',
            mainTaxesOnly: !isNaN(this.props.mainTaxesOnly) ? this.props.mainTaxesOnly : true,
            tableTax: this.props.tableTax || null,
        }

        this.onClose = this.props.onClose
        this.handleTaxIdChange = this.handleTaxIdChange.bind(this)
        this.closeModals = this.closeModals.bind(this)
        this.applyTax = this.applyTax.bind(this)
    }

    applyTax(event) {
        event.preventDefault()
        let field = "taxId"
        switch (this.state.billingMethod) {
            case 'monthly':
                field = "monthlyTaxId"
                break
            case 'yearly':
                field = "yearlyTaxId"
                break
        }

        if ( this.props.objectId && !this.props.stockDocument ) {
            this.props.dispatch(patchPricingTableItem(this.props.objectId, this.props.mainObjectId, this.props.type, {
                [field]: this.state.taxId,
            }, true, true))
                this.closeModals()
        } else {
            let documentId = this.props.mainObjectId ? this.props.mainObjectId : (this.props.invoiceId ? this.props.invoiceId : this.props.quoteId)
            AppContext.getApiClient().patch(`/${this.props.mainObject}/${documentId}`, {
                [field]: this.state.taxId,
            } ).then( r => {
                if ( this.props.onChange ) {
                    this.props.onChange()
                }
                
                this.closeModals()
            })
        }
    }

    handleTaxIdChange(taxId) {
        this.setState({
            taxId: taxId
        });
    }

    componentDidMount() {
        $('#applyTaxModal').modal('show')
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            tableTax: nextProps.tableTax || null,
        })
    }

    closeModals() {
        $('#applyTaxModal').modal('hide')
        this.onClose()
    }


    render() {
        return (
            <div>
                {/************** Discount quote Modal ***************/}
                <div className="modal fade"
                    id="applyTaxModal"
                    role="dialog"
                    aria-hidden="true"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title pb-0 mb-0 border-0" id="setDiscountModalLabel">
                                    <FormattedMessage
                                        id="quote.set_tax_modal.title"
                                        defaultMessage="Tax"
                                    />
                                </h5>
                                <button type="button" className="close" onClick={this.closeModals} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="container-fluid">
                                    <TaxSelect
                                        value={this.state.taxId}
                                        onChange={this.handleTaxIdChange}
                                        mainTaxesOnly={this.state.mainTaxesOnly}
                                        tableTax={this.state.tableTax} />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={this.closeModals}>
                                    <FormattedMessage
                                        id="quote.set_tax_modal.close_btn"
                                        defaultMessage="Close"
                                    />
                                </button>
                                <button type="button" className="btn btn-primary" onClick={this.applyTax}>
                                    <FormattedMessage
                                        id="quote.set_tax_modal.apply_discount_btn"
                                        defaultMessage="Apply Tax"
                                    />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapState = ( state, props ) => {
    const id = props.mainObjectId
    let pricingTableId = getPricingTableId( state, id )
    if ( props.stockDocument ) {
        pricingTableId=props.stockDocument.tableId
    }
    return {
        ...props,
        pricingTableId: pricingTableId
    }
}
const mapDispatch = (dispatch) => { 
    return {
    setPricingTableTotals : setPricingTableTotals, 
    dispatch : dispatch }

}
export default connect(mapState, mapDispatch)(injectIntl(TaxQuote))





// WEBPACK FOOTER //
// ./src/quote/tax.component.jsx